// extracted by mini-css-extract-plugin
module.exports = {"container":"blocks-text-container"};